import { AgendaMedico2Component } from 'src/app/components/agenda-medico2/agenda-medico2.component';
import { CompleterService, CompleterData } from 'ng2-completer';
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { PlansService } from '../../../services/plans.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from 'src/app/services/schedule.service';
import { URL_DOCS } from 'src/app/config/config';
import Swal from 'sweetalert2';
import { PaymentButtonComponent } from 'src/app/components/payment-button/payment-button.component';
import { CanDeactivateGuard } from '../../../services/can-deactivate.guard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/**Snabb */
import { Subscription, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FonasaVoucherService, VoucherStatusResponse } from 'src/app/services/fonasaSnabb.service';
/**Snabb */

@Component({
  selector: 'app-reserva-hora',
  templateUrl: './reserva-hora.component.html',
  styleUrls: ['./reserva-hora.component.css']
})
export class ReservaHoraComponent implements OnInit, OnDestroy {

  // =========================================================
  // INPUTS / VIEWCHILD
  // =========================================================
  @Input() vista_externa: boolean = false;
  @Input() beneficiario_externo: any = false;

  @ViewChild('ErrorModal') trigErrorModal: ElementRef;
  @ViewChild(AgendaMedico2Component) AGENDA_MEDICO: AgendaMedico2Component;
  @ViewChild(PaymentButtonComponent) payment_button: PaymentButtonComponent;
  @ViewChild('acceptTerminos') exampleModalLong: ElementRef;

  // =========================================================
  // TITULOS / UI
  // =========================================================
  _title = 'Mi agenda';
  _subtitle = 'Reserva tu hora';
  subtitle: string;

  options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  URL_DOCUMENTS = URL_DOCS;

  // =========================================================
  // USUARIO / SESSION / PAGEINFO
  // =========================================================
  _usuario: any = {};
  usuario: any = {};
  pageInfo: any = {};
  MatDialogRef: any;

  // =========================================================
  // DATA RESERVA / SELECCIONES
  // =========================================================
  hoursDay: any = {};
  daySelected: any = {};

  data_appo: any = {};
  data_pending_appo: any = {};
  appointment_reason = '';

  benef_cargado;
  beneficiary_list;
  beneficiary_id;
  speciality_id;
  cusId;

  acompanantes_disp: any = {};
  acompanante_selected: any = {};
  acompanante_id = 0;

  sub_speciality_id;
  id_consulta_reservada: any;

  doctorList: any = [];
  specialityList: any = [];
  availabilityDoctorHourList: any = [];

  showOptionMedical: boolean = true;
  showSuccessMessage: boolean;

  strDoctorName: string;
  completerData: CompleterData;

  doctorSelected: any = {};
  hourSelected: any = {};
  specialityListByDoctor: any = [];
  specialitySelected: any = {};
  specialitySelectedValue: any = '';

  errorMsg: any = '';

  // =========================================================
  // STEPS (FLUJO)
  // =========================================================
  steps: any = {
    searchDoctor: false,
    selectDate: false,
    completeForm: false,
    payment: false,
    showSummary: false
  };

  // =========================================================
  // PAGOS / DESCUENTOS / CONVENIOS
  // =========================================================
  acceptTerms = false;
  paymentMethod = false;

  selectedPaymentProvider: 'WEBPAY' | 'SNABB' | null = null;

  compatibleSpecialities: any = [];

  beneficiariesXPlans: any = [];
  plansXSpeciality: any = [];
  beneficiariesFilteredBySpeciality: any = [];
  beneficiarySelected: any = {};
  planesXBeneficiario: any = {};
  planesDisponibles: any = [];
  planesSelected: any = {};
  acompList: any[] = [];
  beneficiarieSelectedValue: any = '';

  planSelected: any = {};
  discountCode: any = '';
  discountCodeObject: any = {};
  paymentSelected: any = {};

  paymentInfo: any = {
    originalValue: 0,
    inssuranceDiscount: null,
    inssuranceDiscountValue: 0,
    discountValue: 0,
    finalValue: 0,
    transaction: {
      url: null,
      token: null,
    },
  };

  status_transaction: string | null = null;
  paymentProviderReturn: 'WEBPAY' | 'SNABB' | null = null;
  private paymentFailedShown = false;
  private readonly leavingToPaymentCreatedIdKey = 'leaving_to_payment_created_id';
  // =========================================================
  // ONDEMAND / FILA (EXTRA)
  // =========================================================
  tiempoEspera: any = {};
  salirFilaForm: FormGroup;
  cancelReason: any = [];
  modalActual: string | null = null;
  cancel_reason: string = '';
  enFilaOnDemand: boolean = true;
  isLoadingExitFila: boolean = false;

  // =========================================================
  // SNABB FONASA
  // =========================================================
  isCreatingVoucher = false;
  isWaitingVoucher = false;
  voucherId?: string;
  pagoIdInterno?: number;
  private voucherPollingSub?: Subscription;

  // =========================================================
  // BACK FROM PAYMENT (FIX)
  // =========================================================
  // private readonly leavingToPaymentKey = 'leaving_to_payment';

  private onPageShowHandler = (event: PageTransitionEvent) => {
    if (event.persisted) {
      this.forceExitAfterBackFromPayment();
      return;
    }

    const nav = performance.getEntriesByType?.('navigation')?.[0] as PerformanceNavigationTiming;
    if (nav && nav.type === 'back_forward') {
      this.forceExitAfterBackFromPayment();
    }
  };

  private readonly leavingToPaymentReturnUrlKey = 'leaving_to_payment_return_url';

  private paymentErrorHandled = false;
  private mustShowWebpayFailedOnLoad = false;

  constructor(
    public generalService: GeneralService,
    private completerService: CompleterService,
    public scheduleService: ScheduleService,
    public router: Router,
    private renderer: Renderer2,
    public plansService: PlansService,
    private activatedRoute: ActivatedRoute,
    public confirmDialog: CanDeactivateGuard,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private fonasaVoucherService: FonasaVoucherService
  ) {

    this.activatedRoute.params.subscribe((parametros) => {
      const id = parametros?.id_consulta;
      const status = (parametros?.status || '').toString().toUpperCase();

      this.status_transaction = status || null;

      // ✅ Si vuelve con /FAILED, NO muestres todavía (porque obtenerConsulta cierra Swal)
      if (!this.paymentErrorHandled && status === 'FAILED') {
        this.mustShowWebpayFailedOnLoad = true;
        this.paymentErrorHandled = true;
        this.skipDeactivateGuard = true;
      }

      if (id) {
        this.obtenerConsulta(id);
      }
    });

    this.pageInfo = new EncriptacionService().getPageInfo();

    this.salirFilaForm = this.fb.group({
      paciente: [null, Validators.required],
      id_ondemand: [null, Validators.required],
      reason: ['', Validators.required]
    });
  }


  // =========================================================
  // INIT / DESTROY
  // =========================================================
  ngOnInit(): void {
    // ✅ primero usuario/pageInfo (mínimo necesario)
    this.usuario = new EncriptacionService().getUserInfo();

    if (!this.vista_externa) this._usuario = this.usuario;
    else this._usuario = this.beneficiario_externo;

    // ✅ Si venimos de un portal de pago (redir normal o back), forzamos ir a pendiente
    const leaving = sessionStorage.getItem(this.leavingToPaymentKey) === '1';
    const pendingId =
      sessionStorage.getItem(this.leavingToPaymentPendingIdKey) ||
      sessionStorage.getItem(this.leavingToPaymentCreatedIdKey);

    // 👇 toma status desde URL (snapshot) o desde tu variable
    const statusFromUrl = (this.activatedRoute.snapshot.paramMap.get('status') || '').toUpperCase();
    const status = statusFromUrl || (this.status_transaction || '').toUpperCase();

    if (leaving && pendingId) {
      this.skipDeactivateGuard = true;

      // ✅ limpia flags pegados
      this.clearLeavingToPayment();

      // ✅ preserva FAILED si venía en la URL
      const target = (status === 'FAILED')
        ? ['/reserva-pendiente', pendingId, 'FAILED']
        : ['/reserva-pendiente', pendingId];

      this.router.navigate(target, { replaceUrl: true });
      // return;
    }

    // ===== init normal =====
    if (this.usuario.typ_id == 2) this.postListUsersWaitList();

    // ✅ reset estado éxito para que no quede pegado
    this.successType = null;
    this.successSubtitle = '';
    this.id_consulta_reservada = null;
    this.showSuccessMessage = false;

    this.steps = {
      searchDoctor: true,
      selectDate: false,
      completeForm: false,
      payment: false,
      showSummary: false,
    };

    this.changeSubtitle(1);

    this.cusId = this.pageInfo.cus_id;

    this.getDoctorList(null, null, null, null, this.cusId);
    this.getSpecialityList();
    this.postListBeneficiariesXPlans();

    window.addEventListener('pageshow', this.onPageShowHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('pageshow', this.onPageShowHandler);
    this.stopVoucherPolling();
  }

  // =========================================================
  // FIX HELPERS
  // =========================================================
  private readonly leavingToPaymentKey = 'leaving_to_payment';
  private readonly leavingToPaymentModeKey = 'leaving_to_payment_mode';
  private readonly leavingToPaymentPendingIdKey = 'leaving_to_payment_pending_id';

  private readonly leavingToPaymentProviderKey = 'leaving_to_payment_provider';


  private markLeavingToPayment(provider?: 'WEBPAY' | 'SNABB', createdOrPendingId?: number | string): void {
    sessionStorage.setItem(this.leavingToPaymentKey, '1');
    sessionStorage.setItem(this.leavingToPaymentReturnUrlKey, this.router.url);

    if (provider) sessionStorage.setItem(this.leavingToPaymentProviderKey, provider);
    else sessionStorage.removeItem(this.leavingToPaymentProviderKey);

    // ✅ prioridad: si ya estás en pendiente, usa ese
    const pendingId = this.data_pending_appo?.id_consulta;
    const idToStore = pendingId || createdOrPendingId || this.id_consulta_reservada;

    if (idToStore) {
      sessionStorage.setItem(this.leavingToPaymentModeKey, 'PENDING');
      sessionStorage.setItem(this.leavingToPaymentPendingIdKey, String(idToStore));
      sessionStorage.setItem(this.leavingToPaymentCreatedIdKey, String(idToStore));
    } else {
      sessionStorage.setItem(this.leavingToPaymentModeKey, 'NORMAL');
      sessionStorage.removeItem(this.leavingToPaymentPendingIdKey);
      sessionStorage.removeItem(this.leavingToPaymentCreatedIdKey);
    }
  }




  private clearLeavingToPayment(): void {
    sessionStorage.removeItem(this.leavingToPaymentKey);
    sessionStorage.removeItem(this.leavingToPaymentModeKey);
    sessionStorage.removeItem(this.leavingToPaymentPendingIdKey);
    sessionStorage.removeItem(this.leavingToPaymentReturnUrlKey);
    sessionStorage.removeItem(this.leavingToPaymentProviderKey);
    sessionStorage.removeItem(this.leavingToPaymentCreatedIdKey); // ✅
  }


  public skipDeactivateGuard = false;

  private async forceExitAfterBackFromPayment(): Promise<void> {
    const leaving = sessionStorage.getItem(this.leavingToPaymentKey) === '1';
    if (!leaving) return;

    const provider = (sessionStorage.getItem(this.leavingToPaymentProviderKey) || '').toUpperCase();
    const status = (this.status_transaction || '').toUpperCase();

    // ✅ id que DEBEMOS abrir como pendiente
    const pendingId =
      sessionStorage.getItem(this.leavingToPaymentPendingIdKey) ||
      sessionStorage.getItem(this.leavingToPaymentCreatedIdKey);

    this.clearLeavingToPayment();

    try { this.safeSwalClose(); } catch { }
    try { this.stopVoucherPolling(); } catch { }

    this.isWaitingVoucher = false;
    this.isCreatingVoucher = false;
    this.skipDeactivateGuard = true;

    // ✅ Siempre vuelve a pendiente si hay id
    if (pendingId) {
      // Si volvió con FAILED desde Webpay, muestra modal antes o después (yo lo haría antes)
      if (provider === 'WEBPAY' && status === 'FAILED' && !this.paymentFailedShown) {
        this.paymentFailedShown = true;
        await this.showPaymentProblemModal();
        setTimeout(() => (this.paymentFailedShown = false), 5000);
      }

      // ✅ Aquí está la clave: no volver a reserva-hora paso 1
      this.router.navigate(['/reserva-pendiente', pendingId], { replaceUrl: true });
      return;
    }

    // Si por alguna razón no hay id, cae a dashboard o donde prefieras
    this.router.navigate(['/dashboard'], { replaceUrl: true });
  }





  // =========================================================
  // MODO "PENDIENTE DE PAGO" (cuando viene id_consulta por ruta)
  // =========================================================
  obtenerConsulta(id_consulta: any) {
    const idNum = Number(id_consulta || 0);

    // 🔥 MUY IMPORTANTE: limpiar cualquier descuento previo
    this.resetDiscountUIState();
    // ✅ reset éxito al cargar pendiente por URL
    this.showSuccessMessage = false;
    this.successType = null;
    this.successSubtitle = '';
    this.id_consulta_reservada = null;
    this.generalService.modalCargando();

    this.scheduleService.getListarConsultasPendientes(id_consulta)
      .then(async (resultado) => {
        try { this.safeSwalClose(); } catch { }

        if (!resultado) {
          this.generalService.modalError(
            "Reserva no disponible",
            "Esta reserva ya no se encuentra como pendiente de pago"
          );
          this.router.navigate(["dashboard"]);
          return;
        }

        this.setPendingData(resultado);

        this.steps = {
          searchDoctor: false,
          selectDate: false,
          completeForm: false,
          payment: true,
          showSummary: false,
        };

        this.changeSubtitle(4);

        await this.maybeShowWebpayFailedModalAfterLoad(id_consulta);
      });
  }
  private async maybeShowWebpayFailedModalAfterLoad(id: any): Promise<void> {
    const status = (this.status_transaction || '').toUpperCase();

    // ✅ si no venía FAILED, nada
    if (!this.mustShowWebpayFailedOnLoad || status !== 'FAILED') return;

    // ✅ marca consumido antes de mostrar
    this.mustShowWebpayFailedOnLoad = false;

    // ✅ muestra modal
    await this.showPaymentProblemModal();


    // ✅ limpia URL para que no se repita en refresh:
    // /reserva-pendiente/3805/FAILED  -> /reserva-pendiente/3805
    this.router.navigate(['/reserva-pendiente', id], { replaceUrl: true });
  }



  private setPendingData(resultado: any) {
    // ✅ reset de éxito en carga de pendiente
    this.showSuccessMessage = false;
    this.successType = null;
    this.successSubtitle = '';
    // ojo: aquí NO siempre quieres borrar id si ya lo tienes, pero es seguro:
    // this.id_consulta_reservada = null;

    this.data_pending_appo = resultado;
    // ✅ aquí decides si esa consulta realmente tiene código
    this.hydrateDiscountFromPending(resultado);

    // carga normal de datos
    this.modifyData(resultado);

    // planes
    this.buildPlanesDisponiblesPendiente();
  }

  modifyData(data: any) {
    this.doctorSelected.att_path = data.att_path;
    this.doctorSelected.nombre_completo = data.nombre_doctor;
    this.specialitySelected.spe_name = data.spe_name;

    // Pendiente: viene "hoy/dia/mes"
    this.daySelected.dateString = (data.hoy || '') + data.dia + ' de ' + (data.mes ? data.mes.toLowerCase() : '');

    this.hourSelected.from = data.hora;
    this.hourSelected.to = data.hora_fin;

    // ben_id de la consulta (si existe)
    this.planSelected.ben_id = data.ben_id;

    this.paymentInfo.finalValue = Number(data.cha_final_value || 0);
    this.paymentInfo.originalValue = Number(data.cha_value_no_discount || 0);
    this.paymentInfo.inssuranceDiscountValue = Number(data.cha_insurance_discount_value || 0);
    this.paymentInfo.discountValue = Number(data.cha_discount_value || 0);
  }

  // ✅ Builder específico para pendiente
  // Toma planes desde data_pending_appo.planesUsuario y filtra por la especialidad de la consulta
  private buildPlanesDisponiblesPendiente(): void {
    const planes = this.data_pending_appo?.planesUsuario || [];
    const speIdConsulta = Number(this.data_pending_appo?.sub_spe_pri_sub_spe_id || 0); // ej: 43

    this.planesDisponibles = [];

    if (!planes.length || !speIdConsulta) return;

    for (const plan of planes) {
      const especialidades = plan?.especialidades || [];
      const match = especialidades.find((e: any) => Number(e?.spe_id) === speIdConsulta);

      if (match) {
        // ✅ calcular info de consultas para ESTA especialidad (pendiente)
        const cantidad = (match.cantidad_consultas === null || match.cantidad_consultas === undefined)
          ? null
          : Number(match.cantidad_consultas);

        const usadas = Number(match.consultas_usadas || 0);

        // si cantidad es null => ilimitadas
        const disponibles = (cantidad === null) ? null : Math.max(cantidad - usadas, 0);

        // ✅ clonar plan y agregarle la info ya lista para UI
        this.planesDisponibles.push({
          ...plan,
          // info “resuelta” para render
          especialidadPendiente: {
            spe_id: Number(match.spe_id),
            spe_name: match.spe_name,
            porcentaje_descuento: Number(match.porcentaje_descuento || 0),
            cantidad_consultas: cantidad,           // null => ilimitadas
            consultas_usadas: usadas,
            consultas_disponibles: disponibles,     // null => ilimitadas
            is_ilimitado: (cantidad === null)
          }
        });
      }
    }

    // ✅ ordenar (opcional): primero los que tienen más disponibles, luego ilimitados arriba, etc.
    // Si quieres otro criterio me dices.
    this.planesDisponibles.sort((a: any, b: any) => {
      const aInfo = a.especialidadPendiente;
      const bInfo = b.especialidadPendiente;

      // ilimitados primero
      if (aInfo?.is_ilimitado && !bInfo?.is_ilimitado) return -1;
      if (!aInfo?.is_ilimitado && bInfo?.is_ilimitado) return 1;

      // luego por disponibles desc
      const aDisp = aInfo?.consultas_disponibles ?? -1;
      const bDisp = bInfo?.consultas_disponibles ?? -1;
      return bDisp - aDisp;
    });

    // ✅ si la consulta ya tenía ben_id, intenta seleccionarlo
    const benId = Number(this.data_pending_appo?.ben_id || 0);
    if (benId) {
      const found = this.planesDisponibles.find((p: any) => Number(p?.ben_id) === benId);
      if (found) this.planSelected = found;
    }
  }


  // =========================================================
  // PASO 1: LISTADOS (MÉDICOS / ESPECIALIDADES / BENEFICIARIOS)
  // =========================================================
  postListBeneficiariesXPlans() {
    this.plansService.postListBeneficiariesXPlans(this._usuario.use_id ? this._usuario.use_id : this._usuario._id)
      .then((data: any) => {
        if (data !== null && data.length > 0) {
          this.beneficiariesXPlans = data;

          // En pendiente NO usamos este flujo para planes, pero no hace daño.
          // Si en tu proyecto te pisa planesDisponibles, puedes protegerlo:
          // if (!this.data_pending_appo?.id_consulta) { ... }
          if (!this.data_pending_appo?.id_consulta) {
            this.changeBeneficiary(this._usuario.use_id ? this._usuario.use_id : this._usuario._id);
          }
        }
      })
      .catch(e => console.error(e));
  }

  getSpecialityList() {
    this.generalService.getSpecialityList()
      .then((data: any) => {
        if (data !== null && data.length > 0) {
          this.specialityList = data;
        }
      })
      .catch(e => console.error(e));
  }

  onChangeSpeciality(specialityId: string) {
    this.getDoctorList(null, specialityId, null, false, this.cusId);
  }

  getDoctorList(doctorID: number = null, specialityIdSelected: string = null, zoom: boolean = null, hours_disp: boolean = null, cusId: number = null) {
    this.generalService.modalCargando();
    this.generalService.getDoctorList(doctorID, specialityIdSelected, zoom, hours_disp, this.cusId)
      .then((data: any) => {
        if (data !== null && data.length > 0) {

          this.doctorList = data;

          for (let doc of this.doctorList) {
            doc.nombre_completo = doc.use_name + ' ' + doc.use_paternal_surname + ' ' + doc.use_maternal_surname;

            try {
              doc.primera_hora = new Date(
                doc.horas_disponibles[0].sch_date.substr(0, 4),
                (doc.horas_disponibles[0].sch_date.substr(5, 2) - 1),
                doc.horas_disponibles[0].sch_date.substr(8, 2),
                doc.horas_disponibles[0].sch_hou_from.substr(0, 2),
                doc.horas_disponibles[0].sch_hou_from.substr(3, 2)
              );
              doc.primera_fecha = doc.primera_hora.toLocaleString('es-US', this.options);
              doc.primera_fecha = this.normalizarFecha(doc.primera_fecha);
            } catch (e) { }

            try {
              doc.segunda_hora = new Date(
                doc.horas_disponibles[1].sch_date.substr(0, 4),
                (doc.horas_disponibles[1].sch_date.substr(5, 2) - 1),
                doc.horas_disponibles[1].sch_date.substr(8, 2),
                doc.horas_disponibles[1].sch_hou_from.substr(0, 2),
                doc.horas_disponibles[1].sch_hou_from.substr(3, 2)
              );
              doc.segunda_fecha = doc.segunda_hora.toLocaleString('es-US', this.options);
              doc.segunda_fecha = this.normalizarFecha(doc.segunda_fecha);
            } catch (e) { }
          }

          this.doctorList.sort(this.compare);
          this.completerData = this.completerService.local(this.doctorList, 'nombre_completo', 'nombre_completo');
          this.reordenarDoctorList();

        } else {
          this.doctorList = [];
        }

        this.safeSwalClose();
      })
      .catch(e => {
        console.error(e);
        this.safeSwalClose();
      });
  }

  normalizarFecha(input) {
    input = input.toLowerCase();
    input = input.replace(",", "");
    return input.substring(0, 1).toUpperCase() + input.substring(1);
  }

  changeDoctor($event) {
    if ($event) {
      this.doctorSelected = $event.originalObject;
      this.getDoctorList(this.doctorSelected.doc_id, null, null, null, this.cusId);
    } else {
      this.getDoctorList(null, null, null, null, this.cusId);
    }
  }

  compare(a, b) {
    try {
      if (a.doc_order_priority !== b.doc_order_priority) {
        return a.doc_order_priority - b.doc_order_priority;
      }

      if (a.primera_hora && b.primera_hora) {
        return a.primera_hora.getTime() - b.primera_hora.getTime();
      }

      if (a.primera_hora && !b.primera_hora) return -1;
      if (!a.primera_hora && b.primera_hora) return 1;

      return 0;
    } catch (e) {
      console.log(e);
    }
    return 0;
  }

  reordenarDoctorList() {
    var list_con_horas = [];
    var list_sin_horas = [];
    var list_unida = [];

    for (let index = 0; index < this.doctorList.length; index++) {
      const element = this.doctorList[index];
      if (element.primera_hora) list_con_horas.push(element);
      else list_sin_horas.push(element);
    }

    for (let index = 0; index < list_con_horas.length; index++) list_unida.push(list_con_horas[index]);
    for (let index = 0; index < list_sin_horas.length; index++) list_unida.push(list_sin_horas[index]);

    this.doctorList = list_unida;
  }

  // =========================================================
  // PASO 2: AGENDA
  // =========================================================
  horasDisponibles(doc_id) {
    this.scheduleService.getScheduleHoursDisp(doc_id, null, true)
      .then(data => {
        this.doctorSelected.hours_of_month = data;
        this.AGENDA_MEDICO.sendToAgendaMedico(this.doctorSelected.hours_of_month, this.doctorSelected.primera_hora);
      });
  }

  clickHourAgendaMedico(data) {
    this.daySelected = data.day;
    this.hourSelected = data.hour;
    this.redirectToStep3(this.hourSelected);
    this.changeBeneficiary(this._usuario.use_id ? this._usuario.use_id : this._usuario._id);
  }

  clickHourDoctor(data, posicion, fecha) {
    this.doctorSelected = data;

    this.resetSpecialities(data);

    this.daySelected = {};
    this.appointment_reason = '';
    this.steps.searchDoctor = false;
    this.steps.selectDate = true;

    this.daySelected.dateInt = data.horas_disponibles[posicion].sch_date.substr(0, 4) + data.horas_disponibles[posicion].sch_date.substr(5, 2) + data.horas_disponibles[posicion].sch_date.substr(8, 2);
    this.daySelected.dateString = fecha.toLocaleString('es-US', this.options);

    this.hourSelected = data.horas_disponibles[posicion];
    this.hourSelected.from = this.hourSelected.sch_hou_from;
    this.hourSelected.to = this.hourSelected.sch_hou_to;

    this.redirectToStep3(this.hourSelected);
    this.changeBeneficiary(this._usuario.use_id ? this._usuario.use_id : this._usuario._id);
  }

  // =========================================================
  // PASO 3: FORMULARIO
  // =========================================================
  changeBeneficiary(use_id) {
    this.acompList = [];
    this.beneficiary_id = use_id;
    this.beneficiarySelected = undefined;
    this.specialitySelectedValue = '';
    this.specialitySelected = {};
    this.planSelected = {};
    this.paymentInfo.inssuranceDiscount = null;
    this.paymentInfo.inssuranceDiscountValue = 0;

    for (let index = 0; index < this.beneficiariesXPlans.length; index++) {
      const element = this.beneficiariesXPlans[index];

      if (element.use_id == use_id) {
        this.beneficiarySelected = element;
      } else {
        if (element.user_age > 15) {
          this.acompList.push(element);
        }
      }
    }

    this.compatibleSpecialities = [];

    if (this.doctorSelected && this.doctorSelected.specialties) {
      if (this.beneficiarySelected && this.beneficiarySelected.planes && this.beneficiarySelected.planes.length > 0 && !this.pageInfo.cus_can_pay) {

        const uniqueSpeIds = new Set();

        for (let i = 0; i < this.beneficiarySelected.planes.length; i++) {
          const plan = this.beneficiarySelected.planes[i];

          for (let j = 0; j < plan.especialidades.length; j++) {
            const speciality = plan.especialidades[j];
            for (let k = 0; k < this.doctorSelected.specialties.length; k++) {
              const doctorSpeciality = this.doctorSelected.specialties[k];
              if (
                doctorSpeciality.spe_id == speciality.spe_id &&
                this.beneficiarySelected.user_age >= doctorSpeciality.spe_min_age &&
                this.beneficiarySelected.user_age <= doctorSpeciality.spe_max_age && speciality.porcentaje_descuento >= 100
              ) {
                uniqueSpeIds.add(doctorSpeciality.spe_id);
              }
            }
          }
        }

        this.compatibleSpecialities = Array.from(uniqueSpeIds).map(spe_id => {
          return this.doctorSelected.specialties.find(specialty => specialty.spe_id === spe_id);
        });

      } else {

        const uniqueSpeIds = new Set();

        for (let i = 0; i < this.doctorSelected.specialties.length; i++) {
          const doctorSpeciality = this.doctorSelected.specialties[i];
          if (
            this.beneficiarySelected &&
            this.beneficiarySelected.user_age >= doctorSpeciality.spe_min_age &&
            this.beneficiarySelected.user_age <= doctorSpeciality.spe_max_age
          ) {
            uniqueSpeIds.add(doctorSpeciality.spe_id);
          }
        }

        this.compatibleSpecialities = Array.from(uniqueSpeIds).map(spe_id => {
          return this.doctorSelected.specialties.find(specialty => specialty.spe_id === spe_id);
        });
      }
    }

    this.changeSpecialityDisp();
  }

  changeSpeciality(subSpeId: number | string) {
    this.specialitySelected = {};
    this.planSelected = {};
    this.paymentInfo.inssuranceDiscount = null;
    this.paymentInfo.inssuranceDiscountValue = 0;

    const selectedId = Number(subSpeId || 0);
    if (!selectedId) {
      this.changeSpecialityDisp();
      return;
    }

    const especialidadesMedico = this.doctorSelected?.specialties || [];
    let especialidad = especialidadesMedico.find(
      (item: any) => Number(item.sub_spe_id) === selectedId
    );

    // El selector entrega sub_spe_id, que no siempre coincide con spe_id.
    if (!especialidad) {
      const catalogo = this.specialityList.find((item: any) =>
        (item.array || []).some((sub: any) => Number(sub.sub_spe_id) === selectedId)
      );
      if (catalogo) {
        especialidad = especialidadesMedico.find(
          (item: any) => Number(item.spe_id) === Number(catalogo.spe_id)
        );
      }
    }

    if (!especialidad) {
      especialidad = especialidadesMedico.find(
        (item: any) => Number(item.spe_id) === selectedId
      );
    }

    if (especialidad) {
      this.specialitySelected = { ...especialidad, sub_spe_id: selectedId };
    }
    this.changeSpecialityDisp();
  }

  changeSpecialityDisp() {
    this.planesDisponibles = [];

    if (this.beneficiarySelected && this.beneficiarySelected.planes && this.specialitySelected.spe_id) {
      for (let index = 0; index < this.beneficiarySelected.planes.length; index++) {
        const element = this.beneficiarySelected.planes[index];
        if (element.especialidades.length > 0) {

          for (let indice = 0; indice < element.especialidades.length; indice++) {
            const element2 = element.especialidades[indice];

            if (element2.spe_id == this.specialitySelected.spe_id && ((!this.pageInfo.cus_can_pay && element2.porcentaje_descuento >= 100) || this.pageInfo.cus_can_pay)) {
              this.planesDisponibles.push(element);
            }
          }
        }
      }
    }
  }

  changeAcompanante(use_id) {
    this.acompanante_selected = {};
    for (let aco of this.acompList) {
      if (aco.use_id == use_id) {
        this.acompanante_selected = aco;
        break;
      }
    }
  }

  reservar() {
    this.data_appo.reason = this.appointment_reason;
    this.data_appo.symptoms = '';
    this.data_appo.acompanante_use_id = (this.acompanante_id == 0) ? null : this.acompanante_id;
  }

  // =========================================================
  // PASO 4: PAGO
  // =========================================================
  private normalizarPrecio(valor: any): number | null {
    if (valor === null || valor === undefined || String(valor).trim() === '') return null;
    const precio = Number(valor);
    return Number.isFinite(precio) && precio >= 0 ? precio : null;
  }

  private obtenerPrecioEspecialidad(): number | null {
    const speId = Number(this.specialitySelected?.spe_id || 0);
    const subSpeId = Number(this.specialitySelectedValue || 0);
    if (!speId || !subSpeId) return null;

    // Si el profesional tiene precio propio, respetarlo.
    const precioMedico = this.normalizarPrecio(this.specialitySelected?.pri_doc_price);
    // El código anterior consideraba 0 como ausencia de tarifa particular.
    if (precioMedico !== null && precioMedico > 0) return precioMedico;

    // getSpecialityList devuelve el precio dentro de array[].sub_spe_pri_price.
    const especialidadCatalogo = this.specialityList.find(
      (item: any) => Number(item.spe_id) === speId &&
        (item.array || []).some((sub: any) => Number(sub.sub_spe_id) === subSpeId)
    );
    const subEspecialidad = (especialidadCatalogo?.array || []).find(
      (item: any) => Number(item.sub_spe_id) === subSpeId
    );
    const precioCatalogo = this.normalizarPrecio(subEspecialidad?.sub_spe_pri_price);
    if (precioCatalogo !== null) return precioCatalogo;

    // Respaldo: algunos listados de médicos ya incluyen el precio.
    return this.normalizarPrecio(this.specialitySelected?.sub_spe_pri_price);
  }

  redirectToStep4() {
    if (!this.beneficiarySelected?.use_id || !this.specialitySelectedValue ||
        !this.specialitySelected?.spe_id || !this.appointment_reason) {
      this.generalService.modalError('Debes completar todos los campos para continuar.', '');
      return;
    }
    if (!this.pageInfo.cus_can_pay && this.planesDisponibles.length === 0) {
      this.generalService.modalError('Sin planes disponibles.', 'No tienes planes o convenios activos que incluyan esta prestación.');
      return;
    }

    const precioEspecialidad = this.obtenerPrecioEspecialidad();
    if (precioEspecialidad === null) {
      this.generalService.modalError('Precio no disponible.', 'No se pudo obtener el precio de la especialidad seleccionada.');
      return;
    }

    this.discountCodeObject = {};
    this.discountCode = '';
    this.paymentInfo.discountValue = 0;
    this.paymentInfo.originalValue = precioEspecialidad;
    this.calculateFinalValue();

    this.steps.completeForm = false;
    this.steps.payment = true;
    this.changeSubtitle(4);
  }

  // ✅ PLAN SELECT: funciona normal y también en pendiente,
  // y en pendiente te manda al PASO 5 para confirmar.
  planRowSelected(plan: any) {
    this.paymentInfo.inssuranceDiscount = null;
    this.paymentInfo.inssuranceDiscountValue = 0;

    // toggle select
    if (plan?.ben_id == this.planSelected?.ben_id) {
      this.planSelected = {};
    } else {
      this.planSelected = plan;
    }

    // ====== detectar spe_id objetivo según flujo ======
    // normal: usa specialitySelected.spe_id
    // pendiente: viene en data_pending_appo.sub_spe_pri_sub_spe_id (en tu data)
    const speIdNormal = Number(this.specialitySelected?.spe_id || 0);
    const speIdPendiente = Number(this.data_pending_appo?.sub_spe_pri_sub_spe_id || 0);

    const speIdTarget = this.data_pending_appo?.id_consulta ? speIdPendiente : speIdNormal;

    // ====== calcular descuento por especialidad dentro del plan ======
    if (this.planSelected?.ben_id && speIdTarget) {
      // En pendientes el identificador recibido suele ser sub_spe_id.
      const especialidadPendiente = this.data_pending_appo?.id_consulta
        ? this.specialityList.find((item: any) => (item.array || []).some(
            (sub: any) => Number(sub.sub_spe_id) === speIdTarget
          ))
        : null;
      const speIdPlan = Number(especialidadPendiente?.spe_id || speIdTarget);
      const esp = (this.planSelected.especialidades || []).find(
        (e: any) => Number(e?.spe_id) === speIdPlan
      );
      if (esp) {
        const porcentaje = Math.min(100, Math.max(0, Number(esp.porcentaje_descuento || 0)));
        this.paymentInfo.inssuranceDiscount = porcentaje / 100;
      }
    }

    if (this.paymentInfo.inssuranceDiscount !== null) {
      this.paymentInfo.inssuranceDiscountValue = Math.round(
        Number(this.paymentInfo.originalValue || 0) * this.paymentInfo.inssuranceDiscount
      );
    }

    // recalcula finalValue
    this.calculateFinalValue();
    if (this.paymentInfo.finalValue <= 0) {
      this.selectedPaymentProvider = null;
      this.paymentMethod = false;
      this.isCreatingVoucher = false;
      this.isWaitingVoucher = false;
      this.stopVoucherPolling();
    }
  }

  continuarPendienteAResumen() {
    // si hay pago > 0, exige provider (si tu cliente tiene providers)
    const canPayByProvider = this.getAvailablePaymentProviders().length > 0;

    if (this.usuario?.typ_id == 2 && this.paymentInfo.finalValue > 0 && canPayByProvider) {
      if (!this.hasValidPaymentSelection()) {
        this.generalService.modalError('Debes seleccionar un método de pago para continuar.', '');
        return;
      }
    }

    // términos
    if (!this.acceptTerms && this.usuario?.typ_id == 2) {
      this.generalService.modalError('Debe aceptar los términos y condiciones para poder atenderse a través de telemedicina.', '');
      return;
    }

    // ✅ pasar al Step 5
    this.steps.payment = false;
    this.steps.showSummary = true;
    this.changeSubtitle(5);
  }

  successType: 'PENDIENTE_CERO' | 'PENDIENTE_PAGO' | 'NORMAL' | null = null;
  successSubtitle: string = '';
  confirmarPendiente() {
  if (!this.data_pending_appo?.id_consulta) return;

  // ✅ Si hay pago, exige provider
  if (Number(this.paymentInfo?.finalValue || 0) > 0) {
    if (!this.selectedPaymentProvider) {
      this.generalService.modalError('Debes seleccionar un método de pago para continuar.', '');
      return;
    }
  }

  this.generalService.modalCargando();

  const typePaymentToSend: 'WEBPAY' | 'SNABB' | null =
    (Number(this.paymentInfo?.finalValue || 0) > 0) ? this.selectedPaymentProvider : null;

  const payload: any = {
    id_consulta: this.data_pending_appo.id_consulta,
    use_id: this.data_pending_appo.use_id,
    typePayment: typePaymentToSend,
    ben_id: this.planSelected?.ben_id || this.data_pending_appo?.ben_id
  };

  this.scheduleService.postPayPendingAppointments(payload)
    .then(async (result: any) => {
      // ✅ Cerrar loading (sin romper si swal está locked)
      try { this.safeSwalClose(); } catch { }

      // =======================================================
      // ✅ CASO 0: convenio/costo 0 => éxito directo
      // =======================================================
      if (!typePaymentToSend) {
        const idOk = Number(result?.id || this.data_pending_appo?.id_consulta || 0);
// console.log(idOk);
// console.log('FUNCIONAAAA');

        this.showSuccess(
          'PENDIENTE_CERO',
          idOk,
          'Se ha enviado el detalle de la reserva al correo electrónico del paciente.'
        );
        // console.log(this.showSuccess);
        
        return;
      }

      // =======================================================
      // ✅ CASO 1: SNABB => iniciar polling + modal de espera
      // =======================================================
      if (typePaymentToSend === 'SNABB') {
        this.voucherId = result?.voucherId;
        this.pagoIdInterno = result?.pagoIdInterno;

        if (!this.voucherId) {
          this.generalService.modalError('Error', 'No se recibió voucherId de SNABB.');
          return;
        }

        // ✅ Guarda flags para back/forward y provider
        this.markLeavingToPayment('SNABB', this.data_pending_appo.id_consulta);

        // ✅ Mantén modal abierto mientras llega payment_url
        this.openPaymentLoading('Redirigiendo a FONASA...');
        this.startVoucherPolling();
        return;
      }

      // =======================================================
      // ✅ CASO 2: WEBPAY => redirigir con flags
      // =======================================================
      if (typePaymentToSend === 'WEBPAY') {
        if (result && result.url) {
          this.paymentInfo.transaction = result;

          await this.generalService.sleep(500);

          // ✅ Muy importante: guardar que nos vamos a pago con este id
          this.markLeavingToPayment('WEBPAY', this.data_pending_appo.id_consulta);

          // ✅ dispara redirect del componente
          this.payment_button.pay();
          return;
        }

        this.generalService.modalError('Error', 'No se recibió la URL de pago.');
        return;
      }

      // =======================================================
      // ✅ FALLBACK: muestra éxito genérico (no dejar “nada”)
      // =======================================================
      const idOk = Number(result?.id || this.data_pending_appo?.id_consulta || 0);
      this.showSuccess(
        'NORMAL',
        idOk,
        'Se ha enviado el detalle de la reserva al correo electrónico del paciente.'
      );
    })
    .catch((err: any) => {
      try { this.safeSwalClose(); } catch { }
      this.generalService.modalError('Error', err?.error?.msg || 'No se pudo procesar la solicitud.');
    });
}



  calculateFinalValue() {
    this.paymentInfo.finalValue = Number(this.paymentInfo.originalValue || 0);

    if (this.paymentInfo.inssuranceDiscountValue && this.paymentInfo.inssuranceDiscountValue > 0) {
      this.paymentInfo.finalValue =
        Number(this.paymentInfo.originalValue || 0) - Number(this.paymentInfo.inssuranceDiscountValue || 0);
    }

    // ✅ solo aplica descuento por código si existe code (evita pegado)
    const hasCode = String(this.discountCodeObject?.code || this.discountCode || '').trim().length > 0;

    if (hasCode && this.discountCodeObject?.dis_id) {
      const subTotal = Number(this.paymentInfo.finalValue || 0);

      const raw = this.discountCodeObject.value;
      const rawStr = String(raw ?? '').trim().replace('%', '').replace(',', '.');
      let value = Number(rawStr);

      if (!Number.isFinite(value) || value <= 0) {
        this.paymentInfo.discountValue = 0;
        return;
      }

      if (Number(this.discountCodeObject.dis_typ_id) === 1) {
        if (value > 1) value = value / 100;
        value = Math.min(Math.max(value, 0), 1);
      }

      let delta = 0;
      if (Number(this.discountCodeObject.dis_typ_id) === 1) delta = subTotal * value;
      if (Number(this.discountCodeObject.dis_typ_id) === 2) delta = value;

      delta = Math.round(delta);

      this.paymentInfo.discountValue = delta > subTotal ? subTotal : delta;
      this.paymentInfo.finalValue = Math.round(subTotal - this.paymentInfo.discountValue);
    } else {
      // ✅ si no hay código, asegurar que no muestre “descuento código”
      this.paymentInfo.discountValue = 0;
    }
  }
  discountAttempted: boolean = false; // ✅ solo muestra mensajes después de "Aplicar"

  validarDcto() {
    this.discountAttempted = true;
    this.discountCodeObject = {};

    const code = (this.discountCode || '').trim().toUpperCase();
    if (!code) {
      this.generalService.modalError('Código no válido', 'Ingrese el código nuevamente');
      return;
    }

    const useId = this.resolveUseIdForDiscount();
    if (!useId) {
      this.generalService.modalError(
        'No se pudo validar el descuento',
        'No se encontró el paciente (useId) para validar el código. Recarga la página o selecciona el beneficiario.'
      );
      return;
    }

    // especialidad: normal vs pendiente
    const speIdNormal = String(this.specialitySelectedValue || '');
    const speIdPendiente = String(this.data_pending_appo?.sub_spe_pri_sub_spe_id || '');
    const speIdToSend = this.data_pending_appo?.id_consulta ? speIdPendiente : speIdNormal;

    if (!speIdToSend) {
      this.generalService.modalError('Error', 'No se pudo identificar la especialidad para validar el descuento.');
      return;
    }

    const payload = { useId, code, speIdToSend };
    // this.logDiscountPayload('ANTES DE validateDiscounts()', payload);

    this.generalService.modalCargando();

    this.plansService
      .validateDiscounts(useId, code, speIdToSend)
      .then((result: any) => {
        this.discountCodeObject = result;

        console.groupCollapsed('✅ [DISCOUNT] RESPUESTA validateDiscounts()');
        // console.log('result completo:', result);
        // console.log('value raw:', result?.value, 'typeof:', typeof result?.value);
        // console.log('dis_typ_id:', result?.dis_typ_id);
        // console.log('formula:', result?.formula);
        console.groupEnd();

        if (this.discountCodeObject?.formula) {
          this.discountCodeObject.formula = this.discountCodeObject.formula.replaceAll('data.', '');
        }

        // deja guardado el code normalizado
        this.discountCode = code;

        // recalcula con normalización y redondeo
        this.calculateFinalValue();

        this.generalService.modalExitoso('Código válido', 'Descuento ingresado exitosamente.');
      })
      .catch((error: any) => {
        console.groupCollapsed('❌ [DISCOUNT] ERROR validateDiscounts()');
        console.log('error completo:', error);
        console.log('error?.error?.msg:', error?.error?.msg);
        console.groupEnd();

        this.discountCodeObject = { status: false };
        this.generalService.modalError('Error al validar código', error?.error?.msg || 'Error al validar código');
      });
  }


  validateTerms() {
  if (this.usuario?.typ_id == 2 && !this.hasPlanOrPaymentSelected()) {
    this.generalService.modalError(
      'Debes seleccionar una opción para continuar.',
      'Selecciona un método de pago o uno de los planes/convenios disponibles.'
    );
    return;
  }

  const canPayByProvider = this.getAvailablePaymentProviders().length > 0;

  // Si queda saldo por pagar, obliga a seleccionar WEBPAY/SNABB
  if (this.usuario?.typ_id == 2 && this.paymentInfo.finalValue > 0 && canPayByProvider) {
    if (!this.hasValidPaymentSelection()) {
      this.generalService.modalError(
        'Debes seleccionar un método de pago para continuar.',
        ''
      );
      return;
    }
  }

  if (!this.acceptTerms && this.usuario?.typ_id == 2) {
    this.generalService.modalError(
      'Debe aceptar los términos y condiciones para poder atenderse a través de telemedicina.',
      ''
    );
    return;
  }

  this.renderer.selectRootElement(this.exampleModalLong.nativeElement).click();
}

  // =========================================================
  // PASO 5: RESUMEN
  // =========================================================
 redirectToStep5() {
  if (this.usuario?.typ_id == 2 && !this.hasPlanOrPaymentSelected()) {
    this.generalService.modalError(
      'Debes seleccionar una opción para continuar.',
      'Selecciona un método de pago o uno de los planes/convenios disponibles.'
    );
    return;
  }

  const canPayByProvider = this.getAvailablePaymentProviders().length > 0;

  if (this.usuario?.typ_id == 2 && this.paymentInfo.finalValue > 0 && canPayByProvider) {
    if (!this.hasValidPaymentSelection()) {
      this.generalService.modalError(
        'Debes seleccionar un método de pago para continuar.',
        ''
      );
      return;
    }
  }

  if (!this.acceptTerms && this.usuario?.typ_id == 2) {
    this.generalService.modalError(
      'Debe aceptar los términos y condiciones para poder atenderse a través de telemedicina.',
      ''
    );
    return;
  }

  this.reservar();
  this.steps.payment = false;
  this.steps.showSummary = true;
  this.changeSubtitle(5);
}

  // =========================================================
  // CONFIRMAR RESERVA
  // =========================================================
  confirm() {
  if (this.usuario?.typ_id == 2 && !this.hasPlanOrPaymentSelected()) {
    this.generalService.modalError(
      'Debes seleccionar una opción para continuar.',
      'Selecciona un método de pago o uno de los planes/convenios disponibles.'
    );
    return;
  }

  if (this.usuario?.typ_id == 2 && this.paymentInfo.finalValue > 0 && !this.selectedPaymentProvider) {
    this.generalService.modalError(
      'Debes seleccionar un método de pago para continuar.',
      ''
    );
    return;
  }

  if (!this.acceptTerms && this.usuario?.typ_id == 2) {
    this.generalService.modalError(
      'Debe aceptar los términos y condiciones para poder atenderse a través de telemedicina.',
      ''
    );
    return;
  }

  this.generalService.modalCargando();

  const typePaymentToSend: 'WEBPAY' | 'SNABB' | null =
    this.paymentInfo?.finalValue > 0 ? this.selectedPaymentProvider : null;

  this.scheduleService.scheduleAppointment(
    this.hourSelected.sch_hou_id,
    this.planSelected?.ben_id || null,
    this.specialitySelectedValue,
    this.data_appo,
    this.beneficiarySelected.use_id,
    this.discountCodeObject?.code,
    typePaymentToSend
  )
    .then(async (data: any) => {
      this.id_consulta_reservada = data.id;
      this.showSuccessMessage = false;
      this.steps.showSummary = false;

      const typePayment = data.paymentType;

      if (typePayment == 'SNABB') {
        this.voucherId = data.transaction.voucherId;
        this.pagoIdInterno = data.id;
        this.startVoucherPolling();
      } else if (typePayment == 'WEBPAY') {
        if (data.transaction && data.transaction.url) {
          this.paymentInfo.transaction = data.transaction;
          await this.generalService.sleep(500);
          this.markLeavingToPayment('WEBPAY', this.id_consulta_reservada);
          this.payment_button.pay();
          this.showSuccessMessage = false;
        } else {
          try { this.safeSwalClose(); } catch { }
          this.showSuccess(
            'NORMAL',
            this.id_consulta_reservada,
            'Se ha enviado el detalle de la reserva a tu correo electrónico.'
          );
        }
      } else {
        try { this.safeSwalClose(); } catch { }

        this.showSuccess(
          'NORMAL',
          this.id_consulta_reservada,
          'Se ha enviado el detalle de la reserva a tu correo electrónico.'
        );
      }
    })
    .catch(async error => {
      this.errorMsg = error.error.msg ? error.error.msg : 'Error a la hora de tomar la reserva';
      this.safeSwalClose();
      this.renderer.selectRootElement(this.trigErrorModal.nativeElement).click();

      if (error.status == 405) {
        this.ngOnInit();
      }
    });
}

  // =========================================================
  // SNABB: POLLING
  // =========================================================
  private startVoucherPolling(): void {
    if (!this.voucherId) return;

    this.isWaitingVoucher = true;
    this.stopVoucherPolling();

    this.voucherPollingSub = interval(3000)
      .pipe(
        switchMap(() => this.fonasaVoucherService.getVoucherStatus(this.voucherId as string))
      )
      .subscribe({
        next: (status: VoucherStatusResponse) => {
          this.handleVoucherStatus(status);
        },
        error: (err) => {
          console.error('Error consultando estado de voucher Fonasa', err);
          this.closePaymentLoading();
          this.isWaitingVoucher = false;
          this.stopVoucherPolling();
          this.generalService.modalError('Error', 'No se pudo consultar el estado del voucher. Intenta nuevamente.');
        }

      });
  }

  private stopVoucherPolling(): void {
    if (this.voucherPollingSub) {
      this.voucherPollingSub.unsubscribe();
      this.voucherPollingSub = undefined;
    }
  }

  private handleVoucherStatus(status: VoucherStatusResponse): void {
    const currentStatus = status.status;

    const paymentUrl = status.payment_url && status.payment_url !== 'null'
      ? status.payment_url
      : null;

    // ✅ Caso ideal: ya tengo payment_url, me voy al portal
    if (paymentUrl && currentStatus === 'Pending') {
      this.isWaitingVoucher = false;
      this.stopVoucherPolling();

      // ✅ IMPORTANTE: si es SNABB, guarda provider
      this.markLeavingToPayment('SNABB', this.id_consulta_reservada);
      window.location.href = paymentUrl;
      return;
    }

    // ❌ Estados terminales no pagables: aquí sí cierro modal y aviso
    if (['Canceled', 'Rejected', 'Expired'].includes(currentStatus)) {
      this.isWaitingVoucher = false;
      this.stopVoucherPolling();

      this.closePaymentLoading();

      this.generalService.modalError(
        'No se pudo iniciar el pago',
        `El voucher quedó en estado: ${currentStatus}. Intenta nuevamente.`
      );
      return;
    }

    // ✅ Pagado / finalizado
    if (['Payed', 'Done'].includes(currentStatus)) {
      this.isWaitingVoucher = false;
      this.stopVoucherPolling();

      this.closePaymentLoading();
      return;
    }

    // 🔁 Si sigue Pending pero aún sin payment_url: mantengo modal abierto
  }



  // =========================================================
  // PAGO PARA CONSULTA PENDIENTE (ya existe id_consulta)
  // =========================================================
  redirectToPayment() {
    // ✅ términos solo aplica si NO es pendiente (flujo normal)
    if (!this.acceptTerms && this.usuario?.typ_id == 2 && !this.data_pending_appo?.id_consulta) {
      this.generalService.modalError('Debe aceptar los términos y condiciones para poder atenderse a través de telemedicina.', '');
      return;
    }

    // ✅ Debe existir id_consulta en pendiente
    if (!this.data_pending_appo?.id_consulta) return;

    // ✅ Si hay pago, exige provider; si no hay pago, NO
    if (this.paymentInfo?.finalValue > 0 && !this.selectedPaymentProvider) {
      this.generalService.modalError('Debes seleccionar un método de pago para continuar.', '');
      return;
    }

    this.generalService.modalCargando();

    // ✅ Si finalValue == 0 => SIEMPRE enviar typePayment null
    const typePaymentToSend: 'WEBPAY' | 'SNABB' | null =
      (this.paymentInfo?.finalValue > 0) ? this.selectedPaymentProvider : null;

    const payload: any = {
      id_consulta: this.data_pending_appo.id_consulta,
      use_id: this.data_pending_appo.use_id,
      typePayment: typePaymentToSend,
      ben_id: this.planSelected?.ben_id || this.data_pending_appo?.ben_id
    };

    this.scheduleService.postPayPendingAppointments(payload)
      .then(async (result: any) => {

        // ✅ Si NO hay pago => éxito directo (no portal)
        if (this.paymentInfo.finalValue <= 0) {
          try { this.safeSwalClose(); } catch { }

          const idOk = Number(result?.id || this.data_pending_appo?.id_consulta || 0);

          this.showSuccess(
            'PENDIENTE_CERO',
            idOk,
            'Se ha enviado el detalle de la reserva al correo electrónico del paciente.'
          );

          return;
        }

        // ✅ SNABB
        // ✅ SNABB: mantener modal abierto hasta redirigir
        if (typePaymentToSend === 'SNABB') {

          this.voucherId = result?.voucherId;
          this.pagoIdInterno = result?.pagoIdInterno;

          if (!this.voucherId) {
            this.closePaymentLoading();
            this.generalService.modalError('Error', 'No se recibió voucherId de SNABB.');
            return;
          }

          // 🔒 Mantén el modal visible durante el polling
          this.openPaymentLoading('Redirigiendo a FONASA...');

          this.startVoucherPolling();
          return;
        }


        // ✅ WEBPAY
        if (typePaymentToSend === 'WEBPAY') {
          if (result && result.url) {
            this.paymentInfo.transaction = result;

            await this.generalService.sleep(500);

            this.markLeavingToPayment('WEBPAY', this.data_pending_appo.id_consulta);
            this.payment_button.pay();
            this.showSuccessMessage = false;
            return;
          }

          try { this.safeSwalClose(); } catch { }
          this.generalService.modalError('Error', 'No se recibió la URL de pago.');
          return;
        }

        // ✅ fallback
        try { this.safeSwalClose(); } catch { }
        try { this.safeSwalClose(); } catch { }

        const idOk = Number(result?.id || this.data_pending_appo?.id_consulta || 0);

        this.showSuccess(
          'PENDIENTE_CERO',
          idOk,
          'Se ha enviado el detalle de la reserva al correo electrónico del paciente.'
        );

        return;
      })
      .catch(async error => {
        this.errorMsg = error?.error?.msg ? error.error.msg : 'Error a la hora de tomar la reserva';
        try { this.safeSwalClose(); } catch { }
        this.renderer.selectRootElement(this.trigErrorModal.nativeElement).click();
        if (error?.status == 405) {
          this.ngOnInit();
        }
      });
  }


  // =========================================================
  // NAVEGACIÓN ENTRE PASOS
  // =========================================================
  redirectToStep1() {
    this.steps.searchDoctor = true;
  }

  redirectToStep2(doctorSelected: object) {
    this.doctorSelected = doctorSelected;
    this.resetSpecialities(doctorSelected);

    this.daySelected = {};
    this.appointment_reason = '';

    this.steps.searchDoctor = false;
    this.steps.selectDate = true;

    this.horasDisponibles((this.doctorSelected as any).doc_id);
    this.changeSubtitle(2);
  }

  redirectToStep3(_item: any) {
    this.steps.selectDate = false;
    this.steps.completeForm = true;
    this.changeSubtitle(3);
  }

  checkStep() {
    this.steps.searchDoctor = true;
    this.steps.selectDate = false;
    this.steps.completeForm = false;
    this.steps.showSummary = false;
    this.steps.payment = false;

    this.changeBeneficiary(this._usuario.use_id ? this._usuario.use_id : this._usuario._id);
    this.changeSubtitle(1);
    this.resetSpecialities(null);
  }

  changeSubtitle(step: number) {
    switch (step) {
      case 1: this.subtitle = 'Selecciona el médico y la fecha que más te acomode.'; break;
      case 2: this.subtitle = 'Próxima hora disponible'; break;
      case 3: this.subtitle = 'Completa tu formulario de reserva'; break;
      case 4: this.subtitle = 'Pago de reserva'; break;
      case 5: this.subtitle = 'Confirma tu reserva'; break;
      case 6: this.subtitle = 'Reserva'; break;
    }
  }

  aMisProximasConsultas() {
    if (!this.vista_externa) {
      var url = "mis-proximas-consultas/";
      this.router.navigate([url]);
    } else {
      setTimeout(() => window.location.reload(), 1000);
    }
  }

  // =========================================================
  // RESETEOS / HELPERS
  // =========================================================
  resetSpecialities(doctorData) {
    this.specialityListByDoctor = doctorData ? (doctorData as any).specialties : [];
    this.specialitySelected = {};
    this.specialitySelectedValue = '';
    this.acompanante_id = 0;
    this.appointment_reason = '';
    this.acceptTerms = false;
    this.paymentMethod = false;

    this.selectedPaymentProvider = null;

    this.planSelected = {};
    this.paymentInfo = {
      originalValue: 0,
      inssuranceDiscount: null,
      inssuranceDiscountValue: 0,
      discountValue: 0,
      finalValue: 0,
      transaction: {
        url: null,
        token: null
      }
    };

    this.discountCode = '';
    this.discountCodeObject = {};
  }

  applyAgreement(_porcentaje_descuento) {
    this.planSelected = {};
  }

  // =========================================================
  // ONDEMAND: LISTA ESPERA + MODALES
  // =========================================================
  postListUsersWaitList() {
    this.scheduleService.postListUsersWaitList(this.usuario._id, this.usuario.typ_id)
      .then((response: any) => {
        this.tiempoEspera = response;
        this.cdRef.detectChanges();
      })
      .catch((error: any) => {
        console.error('Error al obtener la lista de espera:', error);
      });
  }

  confirmarCancelAppoOD() {
    this.scheduleService.postCancelWaitList(
      this.usuario._id,
      this.tiempoEspera.consulta.tel_doc_od_id,
      this.cancel_reason
    )
      .then(_data => {
        Swal.fire({
          allowOutsideClick: false,
          html:
            '<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br><br>' +
            '<h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; align-items: center; text-align: center; color: #171994;">Haz salido de la fila de espera exitosamente</h1> <br>' +
            '<p style="font-family: Mulish; font-style: normal; font-weight: normal; font-size: 18px; line-height: 24px; text-align: center; color: #000000;"></p><br>',
          showConfirmButton: false,
        });

        setTimeout(() => window.location.reload(), 2000);
      })
      .catch(error => console.log("Error cancelando:", error));
  }

  mostrarModal(tipo: string) {
    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                        <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
                        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                            Espere por favor...
                        </h1>
                     </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.salirFilaForm.patchValue({
      paciente: this.usuario._id,
      id_ondemand: this.tiempoEspera.consulta.tel_doc_od_id
    });

    this.scheduleService.getListarCancelReason("ONDEMAND")
      .then((response: any) => {
        this.cancelReason = response;
        this.safeSwalClose();
        this.modalActual = tipo;
        document.body.classList.add("modal-open");
      })
      .catch((error: any) => {
        console.error("Error al obtener los motivos de cancelación:", error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar los motivos de cancelación. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  cerrarModal() {
    this.modalActual = null;
    document.body.classList.remove("modal-open");
  }

  abrirConfirmacionSinDevolucion() {
    this.modalActual = 'confirmarSinDevolucion';
  }

  salirDeFila() {
    const reasonId = this.salirFilaForm.value.reason;
    const pacienteId = this.usuario._id;
    const idOndemand = this.tiempoEspera.consulta.tel_doc_od_id;

    this.isLoadingExitFila = true;

    this.scheduleService.postCancelWaitList(pacienteId, idOndemand, reasonId)
      .then(() => {
        this.modalActual = null;
        this.enFilaOnDemand = false;
        document.body.classList.remove("modal-open");

        this.isLoadingExitFila = false;

        Swal.fire({
          allowOutsideClick: false,
          html: `<i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> 
                       <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 28px; line-height: 48px; text-align: center; color: #171994;"> 
                           Has salido de la fila exitosamente.
                       </h1>`,
          showConfirmButton: false,
          timer: 2000
        });

      })
      .catch(error => {
        console.error("Error al cancelar la espera:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo procesar la solicitud. Inténtalo nuevamente.',
          confirmButtonColor: '#2BABB7'
        });
      });
  }

  // ==============================
  // HELPERS MEDIO DE PAGO
  // ==============================
  getAvailablePaymentProviders(): Array<'WEBPAY' | 'SNABB'> {
    const providers: Array<'WEBPAY' | 'SNABB'> = [];
    if (this.pageInfo?.cus_can_pay) providers.push('WEBPAY');
    if (this.pageInfo?.cus_can_snabb) providers.push('SNABB');
    return providers;
  }

  hasValidPaymentSelection(): boolean {
    if (this.usuario?.typ_id !== 2) return true;
    if (this.paymentInfo?.finalValue <= 0) return true;

    const providers = this.getAvailablePaymentProviders();
    if (!providers.length) return false;

    if (providers.length === 1) {
      return this.selectedPaymentProvider === providers[0];
    }

    return this.selectedPaymentProvider === 'WEBPAY' || this.selectedPaymentProvider === 'SNABB';
  }

  togglePaymentProvider(provider: 'WEBPAY' | 'SNABB', _event?: any) {
    // ✅ si no hay que pagar, no permitas seleccionar provider
    if (this.paymentInfo?.finalValue <= 0) {
      this.selectedPaymentProvider = null;
      this.paymentMethod = false;
      return;
    }

    if (this.selectedPaymentProvider === provider) {
      this.selectedPaymentProvider = null;
      this.paymentMethod = false;
      return;
    }

    this.selectedPaymentProvider = provider;
    this.paymentMethod = true;
  }

  private openPaymentLoading(message: string = 'Espere por favor...'): void {
    Swal.fire({
      allowOutsideClick: false,
      allowEscapeKey: false,
      html: `
      <div style="margin: 40px 0;">
        <i class="material-icons" style="color:#2BABB7; font-size: 58px; margin-bottom:25px">schedule</i>
        <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
          ${message}
        </h1>
      </div>`,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });
  }

  private closePaymentLoading(): void {
    try { this.safeSwalClose(); } catch { }
  }

  private async showPaymentProblemModal(): Promise<void> {
    this.swalLocked = true;

    try {
      await Swal.fire({
        icon: 'error',
        title: 'No se pudo completar el pago',
        html: 'Hubo un problema para realizar el pago, favor reintentar.',
        confirmButtonText: 'Aceptar',

        // si quieres que dure sí o sí hasta que acepten, quita el timer
        // timer: 5000,
        // timerProgressBar: true,

        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => { this.swalLocked = true; },
        willClose: () => { this.swalLocked = false; }
      });
    } finally {
      this.swalLocked = false;
    }
  }

  private resolveUseIdForDiscount(): number | null {
    // 1) normal (cuando usuario/beneficiario ya está cargado)
    const fromBenef = Number(this.beneficiarySelected?.use_id || 0);
    if (fromBenef) return fromBenef;

    // 2) pendiente (si el backend trae use_id)
    const fromPending = Number(this.data_pending_appo?.use_id || 0);
    if (fromPending) return fromPending;

    // 3) fallback: usuario logueado
    const fromUser = Number(this.usuario?._id || this.usuario?.use_id || 0);
    if (fromUser) return fromUser;

    return null;
  }

  private currentPendingConsultaId: number | null = null;

  private resetDiscountUIState(): void {
    this.discountAttempted = false;
    this.discountCode = '';
    this.discountCodeObject = {};
    this.paymentInfo.discountValue = 0;
  }

  /**
   * Solo “reconstruye” el descuento si ESTA consulta lo trae realmente desde backend.
   * Si no viene código (o viene vacío) => limpia para evitar confusión.
   */
  private hydrateDiscountFromPending(data: any): void {
    const discountValue = Number(data?.cha_discount_value || 0);

    // OJO: AJUSTA EL CAMPO SEGÚN TU BACKEND (ejemplos)
    const discountCode =
      String(
        data?.cha_discount_code ??
        data?.discount_code ??
        data?.cha_discount_coupon ??
        ''
      ).trim().toUpperCase();

    // Si NO hay código asociado, NO muestres descuento por código aunque exista cha_discount_value
    // (evita “fantasmas”).
    if (!discountCode) {
      this.resetDiscountUIState();
      return;
    }

    // Si sí hay código, reflejarlo en UI:
    this.discountCode = discountCode;

    // Dejamos un objeto mínimo para que el template sepa que hay descuento aplicado
    this.discountCodeObject = {
      dis_id: true,
      code: discountCode,
      // si tu backend guarda el monto final del descuento, puedes dejarlo así:
      dis_typ_id: 2,
      value: discountValue,
      status: true
    };

    // No recalculamos aquí: en pendiente normalmente ya viene cha_final_value listo.
  }

  async removePendingDiscount(): Promise<void> {
    try {
      const chaId = Number(this.data_pending_appo?.cha_id || 0);
      const code = String(this.data_pending_appo?.dis_code || '').trim();
      const cha_value_no_discount = Number(this.data_pending_appo?.cha_value_no_discount || 0);

      if (!chaId) {
        this.generalService.modalError('Error', 'No se encontró cha_id para quitar el descuento.');
        return;
      }

      if (!code) {
        this.generalService.modalError('Sin descuento', 'Esta reserva no tiene un código aplicado.');
        return;
      }

      // ✅ feedback visual inmediato (evita confusión mientras pega al backend)
      this.data_pending_appo.dis_code = null;
      this.data_pending_appo.dis_id = null;

      this.discountCode = '';
      this.discountCodeObject = {};
      this.paymentInfo.discountValue = 0;

      // si quieres que el total vuelva al "sin descuento código" al tiro:
      // (en pendiente normalmente viene todo desde backend, pero esto ayuda a UI)
      this.paymentInfo.finalValue = Math.round(
        Number(this.paymentInfo.originalValue || cha_value_no_discount || 0) -
        Number(this.paymentInfo.inssuranceDiscountValue || 0)
      );

      this.generalService.modalCargando();

      // ✅ backend: invalidar descuento por cha_id
      await this.plansService.invalidateDiscounts(chaId, cha_value_no_discount);

      // ✅ refresca pendiente para consistencia total
      const idConsulta = Number(this.data_pending_appo?.id_consulta || 0);
      if (idConsulta) {
        const refreshed = await this.scheduleService.getListarConsultasPendientes(idConsulta);
        this.setPendingData(refreshed);
      }

      try { this.safeSwalClose(); } catch { }

    } catch (err: any) {
      try { this.safeSwalClose(); } catch { }

      console.log(err, 'removePendingDiscount');

      this.generalService.modalError(
        'Error',
        err?.error?.msg || 'No se pudo quitar el descuento. Intenta nuevamente.'
      );
    }
  }
  private swalLocked = false;

  private safeSwalClose(): void {
    if (this.swalLocked) return;
    try { Swal.close(); } catch { }
  }

  private showSuccess(type: 'PENDIENTE_CERO' | 'PENDIENTE_PAGO' | 'NORMAL', id: any, subtitle: string = ''): void {
    this.id_consulta_reservada = Number(id || 0);

    this.successType = type;
    this.successSubtitle = subtitle || '';

    // limpiar estados de pago
    this.selectedPaymentProvider = null;
    this.paymentMethod = false;

    this.isWaitingVoucher = false;
    this.isCreatingVoucher = false;
    this.stopVoucherPolling();

    this.showSuccessMessage = true;
    this.steps.showSummary = false;
    this.changeSubtitle(6);
  }

  hasPlanOrPaymentSelected(): boolean {
  const hasPlan = !!this.planSelected?.ben_id;
  const hasPayment = !!this.selectedPaymentProvider;
  return hasPlan || hasPayment;
}
}
